import {success} from "./helpers";
import {
  GET_TAGS_TOTAL,
  GET_CLIENTS_TREE,
  TAGS_SEARCH,
  ALL_TAGS_SEARCH
} from '../actions/TagInfo';
const initialState = {
  tags_total: '',
  tags_tree: [],
  search_results: [],
  all_serach_results: []
}
export const tagsInfo = (state=initialState, action) => {
  switch (action.type) {
    case success(GET_TAGS_TOTAL):
      let obj = [];
      let len = Object.keys(action.payload);

      for (const item of len) {
        let list = Object.assign({}, {
          label: `${item.substring(0, 1).toUpperCase()}${item.substring(1)}`,
          value: action.payload[item]
        });
        obj.push(list);
      }
      return {
        ...state,
        tags_total: obj
      }
    case success(GET_CLIENTS_TREE):
      return {
        ...state,
        tags_tree: action.payload
      }
    case success(TAGS_SEARCH):
      let filterPayload = {
        ...action.payload
      }
      for (const list of filterPayload.clients.data) {
        for (const id of Object.keys(filterPayload.tags)) {
          if (list.id === parseInt(id, 10)) {
            list['children'] = filterPayload.tags[id];
          }
        }
      }
      return {
        ...state,
        search_results: filterPayload
      }
    case success(ALL_TAGS_SEARCH):
      let $filterPayload = {
        ...action.payload
      }
      for (const list of $filterPayload.clients.data) {
        for (const id of Object.keys($filterPayload.tags)) {
          if (list.id === parseInt(id, 10)) {
            list['children'] = $filterPayload.tags[id];
          }
        }
      }
      return {
        ...state,
        all_search_results: $filterPayload
      }
    default:
      return state;
  }
}

export default {
  tagsInfo
}


// WEBPACK FOOTER //
// ./src/reducers/tagsInfo.js